import FeaturedProductBanner from './FeaturedProductBanner';
import CategoryGrid from './CategoryGrid';
import FeaturedProducts from './FeaturedProducts';
import CommunityNewsletter from './CommunityNewsletter';

export default function HomePage() {
  return (
    <div className="bg-df-bg -mt-[var(--navbar-height)]">
      <FeaturedProductBanner />
      <FeaturedProducts />
      <CategoryGrid />
      <CommunityNewsletter />
    </div>
  );
}
